module.exports = __webpack_public_path__ + "static/media/CircleWhite.fabbffbd.png";